import { Pipe } from "@angular/core";
@Pipe({
    name: 'secondsToTime',
    standalone: false
})
export class SecondsToTimePipe {
    times = {
        year: 31557600,
        month: 2629746,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1
    }

    padTime(t) {
        return t < 10 ? "0" + t : t;
    }

    transform(_seconds) {
        if (typeof _seconds !== "number" || isNaN(_seconds) || _seconds < 0)
            return "00:00";
        _seconds = Math.round(_seconds);
        var minutes = Math.floor((_seconds % this.times.day) / this.times.minute),
            seconds = Math.floor(_seconds % this.times.minute);

        return this.padTime(minutes) + ":" + this.padTime(seconds);
    }
}
